import { Chip, Grid, Button } from "@mui/material";
import React from "react";
import { icons } from "../../../../constants";

const FilterSection = ({
  handleFilterModalOpen,
  statusFilterOptions,
  createdDateFilterOptions,
  handleDeleteChip,
  archiveFilterOptions = [],
  toggleArchiveFilter,
}) => {
  const isShowAll = archiveFilterOptions.includes("All");

  return (
    <Grid
      container
      style={{ marginTop: 20, marginBottom: 10 }}
      alignItems={"center"}
    >
      <img
        src={icons.FilterIcon}
        alt="filter icon"
        onClick={handleFilterModalOpen}
        style={filterIconStyles}
      />{" "}
      <span onClick={handleFilterModalOpen} style={filterTextStyles}>
        Filters
      </span>
      <Button
        variant="contained"
        onClick={toggleArchiveFilter}
        sx={{
          backgroundColor: "#00a7cd",
          color: "#fff",
          textTransform: "none",
          fontSize: "14px",
          fontWeight: 600,
          padding: "4px 16px",
          marginLeft: "20px",
          marginRight: "10px",
          "&:hover": {
            backgroundColor: "#00acc1",
          },
        }}
      >
        {isShowAll ? "Show Active Only" : "Show Archived"}
      </Button>
      {statusFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("status", filterItem)}
        />
      ))}
      {createdDateFilterOptions.map((filterItem, index) => (
        <Chip
          label={filterItem}
          key={index}
          style={selectedChipStyles}
          onDelete={() => handleDeleteChip("createdDate", filterItem)}
        />
      ))}
    </Grid>
  );
};

export default FilterSection;

const filterIconStyles = {
  height: 35,
  width: 30,
  marginLeft: 16,
  cursor: "pointer",
};

const filterTextStyles = {
  color: "#00A7CD",
  fontSize: 14,
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};

const selectedChipStyles = {
  marginRight: 10,
  fontWeight: 500,
  fontSize: 14,
  backgroundColor: "#00A7CD",
  paddingLeft: 10,
  paddingRight: 10,
  cursor: "pointer",
  color: "#fff",
  marginLeft: 5,
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};
